<form [formGroup]="credentialsForm" (ngSubmit)="cambiarPass()">
    <div>
      <app-mensajes [code]="code" [titulo]="titulo" [detalle]="detalle"></app-mensajes>
        <div class="register-photo" style="background-color:rgb(255,255,255);">
            <div class="form-container">
                <div class="image-holder">
                    <img src="assets/img/DNM/logo_20.png" class="top-img" style="margin-top: 10%;">
                </div>
                <div class="form" style="align-self: center!important;">
                    <h2 style="text-align: center;"><strong>Cambio de Contraseña</strong></h2>
                    <div class="input-group">
                        <input type="email" required formControlName="correo" id="correo"
                               autocomplete="off" autofocus placeholder="Correo electrónico" pInputText
                               class="ui-inputtext ui-widget">
                        <span *ngIf="credentialsForm.get('correo').hasError('pattern')">
                            <p-message severity="error" text="Verifique el correo electrónico ingresado"></p-message>
                        </span>
                    </div>
                    <div class="input-group">
                        <input type="password" required formControlName="passActual" id="passActual" pInputText
                               autocomplete="off" placeholder="Contraseña actual" class="ui-inputtext ui-widget">
                        <span *ngIf="credentialsForm.get('passActual').hasError('minlength')">
                            <p-message severity="error" text="La contraseña actual debe tener al menos 8 caracteres"></p-message>
                        </span>
                    </div>
                    <div class="input-group">
                        <input type="password" required formControlName="pass" id="pass" autocomplete="off" placeholder="Contraseña nueva" pInputText class="ui-inputtext ui-widget">
                        <span *ngIf="credentialsForm.get('pass').hasError('minlength')">
                            <p-message severity="error" text="La nueva contraseña debe tener al menos 8 caracteres"></p-message>
                        </span>
                    </div>
                    <div class="input-group">
                        <input type="password" required formControlName="passConfirmacion" id="passConfirmacion" autocomplete="off" pInputText placeholder="Confirmación de contraseña nueva" class="ui-inputtext ui-widget">
                        <span *ngIf="credentialsForm.get('passConfirmacion').hasError('minlength')">
                            <p-message severity="error" text="La confirmación debe tener al menos 8 caracteres"></p-message>
                        </span>
                    </div>
                    <div class="input-group">
                        <button type="submit" pButton label="Cambiar contraseña" style="background-color: #313945; border-color: #0D1175;" [disabled]="!credentialsForm.valid">
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <app-spinner [visible]="visibleSpinner"></app-spinner>
    </div>
</form>
